<section class="w-full flex flex-wrap py-4 px-5">
  @if (currentBadge == currentBadgeEnum.challenge) {
    <div class="w-full flex flex-wrap items-center">
      <div class="w-8 h-8 flex justify-center bg-green-10 dark:bg-green-950 ml-2 items-center rounded-full">
        <span class="icon checkmark-circle-regular text-green-500 text-xl"></span>
      </div>
      <span class="text-center text-green-500 font-medium text-lg">تبریک !</span>
    </div>

    <div class="w-full flex flex-wrap justify-center mt-2">
      <div
        class="w-20 h-20 flex flex-wrap justify-center p-4 items-center rounded-full"
        [ngClass]="{ '[background:linear-gradient(0deg,#F5F5F5_-16.48%,rgba(245,245,245,0)_77.12%)]': challenge?.assignedChallenge.hasPhoto }">
        <img
          class="w-14 h-14"
          [ngClass]="{'w-full h-full rounded-full': !challenge?.assignedChallenge?.hasPhoto}"
          loading="lazy"
          onerror="this.src='https://cloud.behkhaan.ir/assets/images/challenge/default-badge.svg'"
          [src]="challenge?.assignedChallenge?.id | image: imageType.challenge : challenge?.assignedChallenge?.hasPhoto : '.svg'" />
      </div>
    </div>
    <div class="w-full flex flex-wrap mt-2">
      <span class="w-full text-sm font-medium text-gray-600">
        {{ challenge?.assignedChallenge?.title }} را با موفقیت به پایان رساندید و
        <span class="text-gray-800 inline text-sm font-medium">
          {{ challenge?.assignedChallenge?.score }}
          امتیاز
        </span>
        کسب کردید.
      </span>

      @if (!challenge?.suggestedChallenge?.id) {
        <span class="w-full font-regular text-xs text-gray-400 mt-2">چالش پیشنهادی بعدی</span>
        <div class="w-full flex flex-wrap items-center bg-gray-50 dark:bg-gray-950 mt-2 py-3 px-4 rounded-xl">
          <div class="w-full flex flex-wrap">
            <div
              class="w-12 h-12 flex flex-wrap justify-center content-center items-center rounded-full ml-3 md:ml-2"
              [ngClass]="{ '[background:linear-gradient(0deg,#F5F5F5_-16.48%,rgba(245,245,245,0)_77.12%)]': challenge?.suggestedChallenge.hasPhoto }">
              <img
                class="rounded-full w-7 h-7 !object-fill"
                [ngClass]="{ '!w-12 !h-12': !challenge?.suggestedChallenge.hasPhoto }"
                loading="lazy"
                onerror="this.src='https://cloud.behkhaan.ir/assets/images/challenge/default-badge.svg'"
                [src]="challenge?.suggestedChallenge?.id | image: imageType.challenge : challenge?.suggestedChallenge?.hasPhoto : '.svg'" />
            </div>
            <div class="flex-1 flex flex-wrap">
              <span class="w-full font-regular text-justify text-xs text-gray-800">{{ challenge?.suggestedChallenge?.title }}</span>
              <div class="w-full flex flex-wrap mt-1">
                <span class="icon book-open-regular text-sm text-gray-500 ml-[3px]"></span>
                <span class="font-regular text-xs text-gray-500">از کتاب انتخابی</span>
              </div>
            </div>
          </div>
          <button type="button" [appButtonLoader]="joinLoading" (click)="joinChallenge(challenge?.suggestedChallenge?.id)" class="btn-green-flat w-full mt-4 rounded-[10px]">پیوستن</button>
        </div>
      } @else {
        <span class="w-full font-regular text-xs text-gray-400 mt-2">چالش پیشنهادی بعدی</span>
        <div class="w-full flex flex-wrap items-center bg-gray-50 dark:bg-gray-950 mt-2 p-4 rounded-xl">
          <span class="w-full text-center font-regular text-xs text-gray-500"> چالش پیشنهادی نداریم! شما همه چالش‌ها را به پایان رساندید :) </span>
        </div>
      }
      <div class="w-full flex flex-wrap divide-solid mt-2">
        <button type="button" class="btn-green !font-medium !text-xs h-8 w-full !rounded-[10px]" (click)="navigateToAllChallenges()">مشاهدهٔ همه چالش‌ها</button>
        <span class="w-full h-[1px] bg-gray-100 dark:bg-gray-900"></span>
        <button type="button" class="btn-green !font-medium !text-xs h-8 w-full !rounded-[10px]" (click)="acknowledge()">متوجه شدم</button>
      </div>
    </div>
  }

  @if(currentBadge == currentBadgeEnum.achievement) {
    <div class="w-full flex flex-wrap">
      <div class="w-full flex flex-wrap items-center">
        <div class="w-8 h-8 flex justify-center bg-green-10 dark:bg-green-950 ml-2 items-center rounded-full">
          <span class="icon checkmark-circle-regular text-green-500 text-xl"></span>
        </div>
        <span class="text-center text-green-500 font-medium text-lg">تبریک !</span>
      </div>
      <div class="w-full flex flex-wrap justify-center">
        <div
            class="w-20 h-20 flex flex-wrap justify-center p-4 items-center rounded-full"
            [ngClass]="{ '[background:linear-gradient(0deg,#F5F5F5_-16.48%,rgba(245,245,245,0)_77.12%)]': achievement?.assignedAchievement.hasPhoto }">
            <img class="w-14 h-14"
            [ngClass]="{'w-full h-full rounded-full': !achievement?.assignedAchievement?.hasPhoto}"
            [src]="achievement?.assignedAchievement.id | image: imageType.achivment : achievement?.assignedAchievement?.hasPhoto : '.svg'"
            onerror="this.src='https://cloud.behkhaan.ir/assets/images/challenge/zero.svg'" />
        </div>
      </div>

      <span class="w-full mt-2 font-medium text-base text-gray-800 text-center">{{achievement?.assignedAchievement.title}}</span>
      <span class="w-full block  mt-2 font-regular text-sm text-gray-800">{{readBooksCount}} کتاب خوانده‌اید و دستاورد {{achievement?.assignedAchievement.title}} را به‌دست آوردید.</span>
      <div class="w-full grid grid-cols-2 gap-[10px] mt-6">
        <button class="btn-green-mute" (click)="allAchievment()">همهٔ دستاوردها</button>
        <button class="btn-green-flat" (click)="closeDialog()">متوجه شدم</button>
      </div>
    </div>

  }
</section>
